"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.OptionsContainer = exports.OptionWrapper = exports.IconWrapper = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Icon = _interopRequireDefault(require("../../Icon"));
var _palette = require("../../../styles/palette");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var OptionsContainer = exports.OptionsContainer = _styledComponents["default"].div.withConfig({
  displayName: "styles__OptionsContainer",
  componentId: "sc-2ntooh-0"
})(["display:flex;flex-direction:column;gap:8px;margin:0 32px 16px 32px;"]);
var OptionWrapper = exports.OptionWrapper = _styledComponents["default"].button.withConfig({
  displayName: "styles__OptionWrapper",
  componentId: "sc-2ntooh-1"
})(["transition:all 0.3s;text-align:left;padding:10px 12px;font-size:14px;border:none;border-radius:3px;background:", ";color:", ";cursor:", ";", ";&:active{background:", ";color:", ";}"], function (p) {
  return p.selected && !p.disabled ? '#298784' : '#F7F7F7';
}, function (p) {
  return p.selected && !p.disabled ? 'white' : '#575F5F';
}, function (p) {
  return p.disabled ? 'default' : 'pointer';
}, function (_ref) {
  var optionDisabled = _ref.optionDisabled;
  return optionDisabled ? 'opacity: 0.5' : '';
}, function (p) {
  return !p.disabled ? '#298784' : '';
}, function (p) {
  return !p.disabled ? 'white' : '';
});
var IconWrapper = exports.IconWrapper = (0, _styledComponents["default"])(_Icon["default"]).withConfig({
  displayName: "styles__IconWrapper",
  componentId: "sc-2ntooh-2"
})(["margin:14px;cursor:pointer;&:hover{color:", ";}"], _palette.commonPalette.btnGreen);
var Wrapper = exports.Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "styles__Wrapper",
  componentId: "sc-2ntooh-3"
})(["display:flex;flex-direction:row;justify-content:space-between;background:#f7f7f7;color:black;"]);
//# sourceMappingURL=styles.js.map